/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ChannelProvider,
    ChannelProviderFromJSON,
    ChannelProviderFromJSONTyped,
    ChannelProviderToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateChannelProviderRequest
 */
export interface CreateChannelProviderRequest {
    /**
     * 
     * @type {ChannelProvider}
     * @memberof CreateChannelProviderRequest
     */
    channelProvider: ChannelProvider;
}

export function CreateChannelProviderRequestFromJSON(json: any): CreateChannelProviderRequest {
    return CreateChannelProviderRequestFromJSONTyped(json, false);
}

export function CreateChannelProviderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateChannelProviderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'channelProvider': ChannelProviderFromJSON(json['channel_provider']),
    };
}

export function CreateChannelProviderRequestToJSON(value?: CreateChannelProviderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'channel_provider': ChannelProviderToJSON(value.channelProvider),
    };
}


